import { gql } from '@apollo/client';

import {
  UtSessionStatusDocument,
  type UtSessionStatusSubscription,
  type UtSessionStatusSubscriptionVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    subscription UtSessionStatus($uniqueId: ID!) {
      utSessionStatus(uniqueId: $uniqueId) {
        status
        reason
        timestamp
      }
    }
  `;
}

export const UT_SESSION_STATUS = UtSessionStatusDocument;
export type {
  UtSessionStatusSubscription,
  UtSessionStatusSubscriptionVariables,
};
